import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { User, Shield, Lock, Bell, Palette, Database, BookmarkCheck, CreditCard, Sparkles } from 'lucide-react';
import ProfileSettings from './ProfileSettings';
import SecuritySettings from './SecuritySettings';
import PrivacySettings from './PrivacySettings';
import NotificationSettings from './NotificationSettings';
import AppearanceSettings from './AppearanceSettings';
import DataSettings from './DataSettings';
import PromptsSettings from './PromptsSettings';
import JproIntelligenceSettings from './JproIntelligenceSettings';
import BillingSettings from './BillingSettings';

function Settings() {
    const location = useLocation();
    const fromChat = location.state?.fromChat === true;
    const fromBilling = location.state?.initialTab === 'billing';
    const initialTab = fromBilling ? 'billing' : fromChat ? 'prompts' : 'profile';
    const [activeTab, setActiveTab] = useState(initialTab);

    const baseTabs = [
        { id: 'profile', label: 'Profile', icon: User },
        { id: 'security', label: 'Security', icon: Shield },
        { id: 'privacy', label: 'Privacy', icon: Lock },
        // { id: 'billing', label: 'Billing', icon: CreditCard },
        { id: 'notifications', label: 'Notifications', icon: Bell },
        { id: 'appearance', label: 'Appearance', icon: Palette },
        { id: 'jpro_intelligence', label: 'JPRO Intelligence', icon: Sparkles },
        { id: 'data', label: 'Data Management', icon: Database },
    ];

    const tabs = fromChat
        ? [...baseTabs, { id: 'prompts', label: 'Prompts', icon: BookmarkCheck }]
        : baseTabs;

    const renderTabContent = () => {
        switch (activeTab) {
            case 'profile':
                return <ProfileSettings />;
            case 'security':
                return <SecuritySettings />;
            case 'privacy':
                return <PrivacySettings />;
            case 'notifications':
                return <NotificationSettings />;
            case 'appearance':
                return <AppearanceSettings />;
            case 'billing':
                return <BillingSettings />;
            case 'jpro_intelligence':
                return <JproIntelligenceSettings />;
            case 'data':
                return <DataSettings />;
            case 'prompts':
                return <PromptsSettings />;
            default:
                return <ProfileSettings />;
        }
    };

    return (
        <div className="p-6 max-w-screen-2xl mx-auto">
            <div className="max-w-5xl mx-auto space-y-6">
                {/* Header */}
                <div className="space-y-2">
                    <h1 className="text-2xl font-dm-serif font-bold">Settings</h1>
                    <p className="text-gray-500 dark:text-gray-400 font-rasa">
                        Manage your account preferences and settings
                    </p>
                </div>

                {/* Tabs */}
                <div className="border-b border-gray-200 dark:border-gray-700">
                    <nav className="flex space-x-1 overflow-x-auto">
                        {tabs.map((tab) => {
                            const Icon = tab.icon;
                            const isActive = activeTab === tab.id;
                            return (
                                <button
                                    key={tab.id}
                                    onClick={() => setActiveTab(tab.id)}
                                    className={`flex items-center space-x-2 px-4 py-3 border-b-2 font-rasa font-medium text-sm whitespace-nowrap transition-colors ${
                                        isActive
                                            ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                                            : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-gray-600'
                                    }`}
                                >
                                    <Icon size={18} />
                                    <span>{tab.label}</span>
                                </button>
                            );
                        })}
                    </nav>
                </div>

                {/* Tab Content */}
                <div className="py-4">
                    {renderTabContent()}
                </div>
            </div>
        </div>
    );
}

export default Settings;
